import {
  AddOutlineMediumIcon,
  AssignmentOutlineMediumIcon,
  CampaignOutlineMediumIcon,
  ForumOutlineMediumIcon,
  ImportantDevicesOutlineMediumIcon,
  LocalActivityOutlineMediumIcon,
  MyLocationOutlineMediumIcon,
  PetAndSafetyOutlineMediumIcon,
  PetTeleconsultatioMediumIcon,
  ProductMedicationsOutlineMediumIcon,
  SearchOutlineMediumIcon,
  UrnOutlineMediumIcon,
  VideoCallOutlineMediumIcon,
} from '@angeplus/prever-component-lib';
import { CLUBE, MEDICAL_PARTNER, POSTHUMOUS, TELEVET } from '../../../routes';

export interface ServiceFeature {
  label: string;
  icon: React.ReactNode;
}

export interface ServiceSection {
  id: string;
  tag: string;
  tagColor: 'pink' | 'gray' | 'green' | 'blue';
  title: string;
  description: string;
  image: string;
  buttonText: string;
  buttonUrl: string;
  features: ServiceFeature[];
  imagePosition: 'left' | 'right';
}

export const SERVICES_SECTIONS: ServiceSection[] = [
  {
    id: 'health',
    tag: 'Cuidados e Saúde',
    tagColor: 'pink',
    title: 'Fale com um médico de forma simples e segura, direto no app.',
    description:
      'Receba atenção de verdade em menos de 3 minutos de fila: atendimento humano, rápido e confiável.',
    image: 'hub_section_health.png',
    buttonText: 'Quero conhecer',
    buttonUrl: MEDICAL_PARTNER,
    imagePosition: 'right',
    features: [
      { label: 'Teleconsulta', icon: <VideoCallOutlineMediumIcon /> },
      { label: 'Guia médico', icon: <AssignmentOutlineMediumIcon /> },
      {
        label: 'Guia de farmácias',
        icon: <ProductMedicationsOutlineMediumIcon />,
      },
      { label: 'e mais...', icon: <AddOutlineMediumIcon /> },
    ],
  },
  {
    id: 'posthumous',
    tag: 'Serviços Póstumos',
    tagColor: 'gray',
    title: 'Apoio completo e humanizado no momento em que você mais precisa.',
    description:
      'Oferecemos assistência funeral completa, garantindo proteção e todo o suporte necessário para sua família em um só lugar.',
    image: 'hub_section_posthumous.png',
    buttonText: 'Quero conhecer',
    buttonUrl: POSTHUMOUS,
    imagePosition: 'left',
    features: [
      {
        label: 'Consulta de falecimento',
        icon: <SearchOutlineMediumIcon />,
      },
      { label: 'Velório online', icon: <ImportantDevicesOutlineMediumIcon /> },
      { label: 'Crematório', icon: <UrnOutlineMediumIcon /> },
      { label: 'e mais...', icon: <AddOutlineMediumIcon /> },
    ],
  },
  {
    id: 'pet',
    tag: 'Para seu Pet',
    tagColor: 'green',
    title: 'Cuidados e descontos pensados para o seu pet.',
    description:
      'Tenha acesso a benefícios e serviços que garantem o bem-estar dos seus companheiros.',
    image: 'hub_section_pet_health.png',
    buttonText: 'Quero conhecer',
    buttonUrl: `${TELEVET}/home`,
    imagePosition: 'right',
    features: [
      { label: 'Teleconsulta Pet', icon: <PetTeleconsultatioMediumIcon /> },
      { label: 'Proteção Pet', icon: <PetAndSafetyOutlineMediumIcon /> },
      { label: 'Assistência Pet', icon: <ForumOutlineMediumIcon /> },
      { label: 'e mais...', icon: <AddOutlineMediumIcon /> },
    ],
  },
  {
    id: 'clube',
    tag: 'Clube de Vantagens',
    tagColor: 'blue',
    title: 'Descontos exclusivos que cuidam do seu bolso e da sua rotina.',
    description:
      'Um clube com descontos exclusivos em produtos e serviços de grandes marcas e parceiros locais.',
    image: 'hub_section_health_plan.png',
    buttonText: 'Quero conhecer',
    buttonUrl: `${CLUBE}/home`,
    imagePosition: 'left',
    features: [
      {
        label: 'Benefícios com desconto',
        icon: <LocalActivityOutlineMediumIcon />,
      },
      { label: 'Anunciar no Clube', icon: <CampaignOutlineMediumIcon /> },
      { label: 'Benefícios próximos', icon: <MyLocationOutlineMediumIcon /> },
      { label: 'e mais...', icon: <AddOutlineMediumIcon /> },
    ],
  },
];
